'use client';

import styled from 'styled-components';

import { StarProps } from '../interfaces/StarRating';

export const StarContainer = styled.div<{ $readOnly?: boolean; $gap?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ $gap }) => $gap || '0.125rem'};
  cursor: ${({ $readOnly }) => ($readOnly ? 'default' : 'pointer')};
  user-select: none;
`;

export const StarWrapper = styled.button<StarProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: ${({ $readOnly }) => ($readOnly ? 'default' : 'pointer')};
  transition: transform 0.1s ease;
  width: ${({ $size }) => $size || '2rem'};
  height: ${({ $size }) => $size || '2rem'};

  & svg {
    width: 100%;
    height: 100%;
    fill: ${({ theme, $isActive }) => $isActive && theme.colors.brand};
    stroke: currentColor;
    color: ${({ theme, $isActive, $isHovered }) =>
    $isActive || $isHovered ? theme.colors.brand : theme.colors.typographyHeadersLight};
    transition:
      color 0.2s ease,
      fill 0.2s ease;
  }
`;
